import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import styles from "./Lottie.module.css";

interface LottieProps {
  loop?: boolean;
  autoplay?: boolean;
  animationData: string;
  height: string;
  width: string;
}

export default function Lottie({
  loop = true,
  autoplay = true,
  animationData,
  height,
  width,
}: LottieProps) {
  const playerRef = useRef(null);
  const divRef = useRef(null);

  useEffect(() => {
    if (divRef.current) {
      playerRef.current = lottie.loadAnimation({
        container: divRef.current,
        loop,
        autoplay,
        animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      });
    }
    return () => {
      playerRef.current?.destroy();
    };
  }, [animationData, autoplay, loop]);

  return <div ref={divRef} className={styles.lottie} style={{ height, width }}></div>;
}
